import { writable, get } from "svelte/store";
import { ActiveTopicStore, normalizeTopicName, } from "$/stores/extension/ActiveTopicStore";
import { ClusterStore, ClusterType } from "./ClusterStore";
import { LocalStorage } from "$/services/LocalStorage";
import { isMobile } from "$/utils/isMobile";
import { TokenStore } from "$/stores/TokenStore";
import { TenantStore } from "$/stores/TenantStore";
import { removeUrlParameters } from "$/utils/Utils";
export var ExtensionPanels;
(function (ExtensionPanels) {
    ExtensionPanels["MAIN"] = "main";
    ExtensionPanels["SETTINGS"] = "settings";
    ExtensionPanels["SHARE"] = "share";
})(ExtensionPanels || (ExtensionPanels = {}));
const defaultHighlight = {
    anchorNode: "",
    anchorOffset: null,
    focusNode: "",
    focusOffset: null,
    pageNumber: null,
    container: "",
    preContent: "",
    postContent: "",
};
class Extension {
    constructor() {
        this.loading = true;
        this.activePanel = ExtensionPanels.MAIN;
        this.selectionHtml = null;
        this.importingFromKindle = false;
        this.card = {
            content: "",
            highlight: defaultHighlight,
        };
    }
}
const store = () => {
    // create store
    const { subscribe, set, update } = writable(new Extension());
    return {
        subscribe,
        set,
        update,
        init: async () => {
            let store = get(ExtensionStore);
            let localValue = await LocalStorage.get("hidePanel");
            // NOTE: on mobile we don't want to show the panel when the extension is opened
            //       because it will cover the content we are trying to locate
            store.opened = get(isMobile) ? false : !localValue;
            set(store);
        },
        createTopic: async (tenantId, clusterId = null) => {
            let store = get(ExtensionStore);
            const topic = {
                name: normalizeTopicName(document.title),
                url: removeUrlParameters(window.location.href),
                snippets: [],
            };
            store.loading = true;
            set(store);
            let newTopic = await ClusterStore.createTopic(topic, {
                id: clusterId,
                clusterType: ClusterType.TENANT_DEFAULT,
            });
            // @ts-ignore
            await ActiveTopicStore.init(newTopic.id, TokenStore, TenantStore, ClusterStore);
            store.loading = false;
            set(store);
        },
        setLoadingStatus: (status) => update((store) => {
            store.loading = status;
            return store;
        }),
        toggleSettingsPanel: () => update((store) => {
            if (store.activePanel === ExtensionPanels.MAIN) {
                store.activePanel = ExtensionPanels.SETTINGS;
            }
            else {
                store.activePanel = ExtensionPanels.MAIN;
            }
            return store;
        }),
        setPanel: (panel) => update((store) => {
            store.activePanel = panel;
            return store;
        }),
        setOpened: (opened) => {
            update((state) => {
                LocalStorage.set("hidePanel", !opened);
                return Object.assign(Object.assign({}, state), { opened });
            });
        },
        clearNewCardContent: () => update((state) => {
            state.card = {
                content: "",
                highlight: Object.assign({}, defaultHighlight),
            };
            return state;
        }),
    };
};
export const ExtensionStore = store();
